import { useTranslations } from 'next-intl'
import styles from './Label.module.css'
import Icon_Info from '@/assets/img/Icon_Info.svg'
import Icon from '../Icon/Icon'
export enum LabelKind {
	NEW,
	RECOMMENDED,
	STEAM_LICENSE,
	EPIC_LICENSE,
	BATTLENET_LICENSE
}

interface LabelProps {
	kind: LabelKind,
	info?: boolean,
	active?: boolean,
	callback?: () => void
}

export default function Label({ kind, info = false, active = false, callback } : LabelProps) {

	const t = useTranslations('Label')

	function handleCallback() {
		if(info) callback!()
	}
	
	return (
		<div data-testid={`Label_${kind}`} className={`${styles.main} ${info ? styles.info : ''} ${active ? styles.active : ''} ${kind === LabelKind.NEW ? styles.new : kind === LabelKind.RECOMMENDED ? styles.recommended : styles.license}`} onClick={handleCallback}>
			<span className='bodyTextSmallStrong'>
				{kind === LabelKind.NEW ? t('new') :
					kind === LabelKind.RECOMMENDED ? t('recommended') :
					kind === LabelKind.STEAM_LICENSE ? t('steamLicense') :
					kind === LabelKind.EPIC_LICENSE ? t('epicLicense') : t('battlenetLicense')
				}
			</span>
			{info && (kind === LabelKind.STEAM_LICENSE || kind === LabelKind.EPIC_LICENSE || kind === LabelKind.BATTLENET_LICENSE ) &&
			<Icon icon={Icon_Info} className={styles.icon}/>}
		</div>
	)
}